// extracted by mini-css-extract-plugin
module.exports = {"w3932fa":"w3932fa"};